import { AxiosInstance, AxiosResponse } from "axios";

export class VideoDescriptionService {
  client: AxiosInstance;
  serviceName = 'video_description/demo-videos-management';
  stats = 'video_description/demo-videos-stats'
  currentStatus = 'video_description/demo-video-status'
  uploadUrl = 'video_description/demo-video-upload'
  constructor({ client }: { client: AxiosInstance }) {
    this.client = client;
  }

  getVideoDescription(videoId: string) {
    return this.client.get(`${this.serviceName}?id=${videoId}`);
  }

  getUploadUrl(params: { file_name: string, file_type: string }): Promise<AxiosResponse<{ presigned_url: string, key: string }>> {
    return this.client.post(`${this.uploadUrl}/`, params);
  }

  getListOfVideos(params: any = {}) {
    const queryParams = new URLSearchParams(params);
    return this.client.get(`${this.serviceName}/?${queryParams.toString()}`);
  }

  createVideoDescription(payload: { attachment: string, file_name: string }) {
    return this.client.post(`${this.serviceName}/`, payload);
  }

  updateAdditionalContext(videoId: string, content: string) {
    return this.client.patch(`${this.serviceName}/${videoId}`, {
      additional_info: content,
    });
  }

  removeVideo(videoId: string) {
    return this.client.delete(`${this.serviceName}/${videoId}/`);
  }

  getStats() {
    return this.client.get(`${this.stats}/`);
  }

  getCurrentStatus(videoId: string) {
    return this.client.get(`${this.currentStatus}?id=${videoId}`);
  }
}